import { createSelector } from '@ngrx/store';

import { AppState } from './app.state';
import { selectAppState } from './user.selectors';

export const selectCurrent2FaStatus = createSelector(selectAppState, (appState: AppState) => appState.twoFaEnabled);

export const selectCurrent2FaStatusLoadingState = createSelector(selectAppState, (appState: AppState) => appState.twoFaEnabledLoaded);

export const selectCurrent2FaDevice = createSelector(selectAppState, (appState: AppState) => appState.twoFaDevice);

export const selectCurrent2FaInfos = createSelector(selectAppState, (appState: AppState) => {
  return { twoFaEnabled: appState.twoFaEnabled, twoFaDevice: appState.twoFaDevice, twoFaEnabledLoaded: appState.twoFaEnabledLoaded };
});
